import type { ExtendedUserInfo } from "@/.shared/services/auth/authentication/extended-user-info";
import { useAuthentication } from "@/.shared/services/auth";
import { useAuthorization } from "@/.shared/services/auth/authorization";
import { PermissionsApp } from "@/.shared/services/auth/authorization/authorization-service-impl";
import type { AuthorizationService } from "@/.shared/services/auth/authorization/authorization-service-impl";
import { computed, type Ref } from "vue";
import { isEmpresaAgentesInmutable } from "@/composables/empresaAgentesAutoregistroValidada";

export function esResponsableEmpresaAgentes(autho: AuthorizationService): boolean {
  return autho.hasPermission(PermissionsApp.EditSameCompanyAgentes)
    || autho.hasPermission(PermissionsApp.EditSameInmobiliariaAgente);
}

export function isCamposIdentidadBloqueados(
  idEstado: string | null | undefined,
  autoregistro: boolean | undefined,
  esResponsable: boolean,
): boolean {
  return isEmpresaAgentesInmutable(idEstado, autoregistro) && esResponsable;
}

export function useEmpresaAgentesCamposIdentidadBloqueados() {
  const auth = useAuthentication();
  const autho = useAuthorization();

  const camposIdentidadBloqueados = computed(() => {
    const user = auth.userInfo as ExtendedUserInfo | null;
    return isCamposIdentidadBloqueados(
      user?.idEstadoEmpresaAgentes,
      user?.autoregistroEmpresaAgentes,
      esResponsableEmpresaAgentes(autho),
    );
  });

  return { camposIdentidadBloqueados };
}

export function crearValidadorCampoInmutable(
  obtenerOriginal: () => string | undefined,
  bloqueado: Ref<boolean>,
) {
  return (e: { value?: string }) => {
    if (!bloqueado.value) {
      return true;
    }
    return e.value === obtenerOriginal();
  };
}
